export const environment = {
  production: true,
  FRONTEND_BASE_URL: "https://portal.ulwsschool.com/",
  BASE_URL: "https://portalapi.ulwsschool.com",
  TRANZGATE_URL: "https://pay.tranzgate.com.ng/",

  logo: "/assets/logos/ulws-logo.png",
  short_name: "ULWS",
  long_name: "University Of Lagos Women Society School",

  nav_links: {
    home: true,
    biodata: true,
    payment: true,
    course: true,
    result: true,
    appointment: true,
    election: true,
    accommodation: true,
    application: true,
    purchases: true,
  },

  remita: true,
  allowedCompanies: [] as string[],
  institution_name: 'UNILAG',
};
